<template>
  <div class="certificate-access-loading d-flex align-items-center justify-content-center min-vh-100">
    <p class="mb-0">Opening certificate…</p>
  </div>
</template>

<script>
import axios from 'axios';

function isAllowedCertificateApiUrl(target) {
  const base = process.env.VUE_APP_API_URL || '';
  if (!base || !target) return false;
  try {
    const u = new URL(target);
    const b = new URL(base);
    if (u.origin !== b.origin) return false;
    const p = u.pathname;
    return (
      p.includes('downloadCourseCertificate') ||
      p.includes('downloadCourseCertificateByEntry') ||
      p.includes('downloadAllCourseCertificate') ||
      p.includes('downloadCourseFoldersCertificate')
    );
  } catch {
    return false;
  }
}

export default {
  name: 'CertificateAccess',
  mounted() {
    this.run();
  },
  methods: {
    async run() {
      let target = this.$route.query.target;
      if (typeof target === 'string') {
        try {
          target = decodeURIComponent(target);
        } catch {
          // keep as-is
        }
      }
      if (!target) {
        const stored = sessionStorage.getItem('certificate_download_target');
        if (stored) target = stored;
      }
      if (!target || !isAllowedCertificateApiUrl(target)) {
        if (this.$toast) {
          this.$toast.error('Invalid certificate link.');
        }
        this.$router.replace('/dashboard');
        return;
      }

      const token = localStorage.getItem('hot-token');
      if (!token) {
        sessionStorage.setItem('certificate_download_target', target);
        this.$router.replace({ name: 'Login' });
        return;
      }

      sessionStorage.removeItem('certificate_download_target');

      try {
        const resp = await axios.get(target, {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + token,
            Accept: 'application/pdf, application/octet-stream, */*',
          },
        });
        const blob = new Blob([resp.data], {
          type: resp.headers['content-type'] || 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 120000);
        this.$router.replace('/dashboard');
      } catch (e) {
        if (this.$toast) {
          this.$toast.error('Could not open certificate. Try again from the app.');
        }
        this.$router.replace('/dashboard');
      }
    },
  },
};
</script>
